import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {RouteParams} from "../../routes";
import {ApiService} from "../../service/api-service";
import {useFilters} from "./useFilters";
import {organizations} from '../../data/organizations.json';

const calculateWorker: Worker = new Worker(window.location.origin + '/workers/data-worker.js');
const useFetchData = (category: string, addValues?: boolean) => {

    let {organization, period} = useParams<RouteParams>();
    const [initialData, setInitialData] = useState<Array<any>>([]);
    const [data, setData] = useState<Array<any>>([]);
    const [filters, activeFilters, setNewFilters, createFilters, setNewFiltersMultiple] = useFilters([]);
    const [initialFilters, setInitialFilters] = useState<Array<any>>([]);

    useEffect(() => {
        if (!calculateWorker) return;
        const tmp: Array<any> = [];

        if (window.location.href.includes('lokalizacja_inwestycji')) {
            tmp.push({
                key: 'regard',
                values: ['Lokalizacja inwestycji celu publicznego']
            })

        } else if (window.location.href.includes('warunki_zabudowy')) {
            tmp.push({
                key: 'regard',
                values: ['Warunki zabudowy']
            })
        } else if (window.location.href.includes('zabytki_archeologiczne')) {
            tmp.push({
                key: 'type',
                values: ['C - zabytek archeologiczny']
            })
        } else if (window.location.href.includes('zabytki')) {
            tmp.push({
                key: 'type',
                values: ['A - zabytek nieruchomy', 'B - zabytek ruchomy']
            })
        }
        calculateWorker.onmessage = ($event: MessageEvent) => {
            if ($event && $event.data) {
                const {type} = $event.data;
                switch (type) {
                    case "newData":
                        setData($event.data.data);
                        break;
                    case "addValues":
                        setInitialData($event.data.data);

                        if ((!organization && !period) && (tmp.length === 0)) {
                            setData($event.data.data);
                        }
                        break;
                }
            }
        };
    }, [calculateWorker]);

    useEffect(() => {

        const tmp: Array<any> = [];

        if (window.location.href.includes('lokalizacja_inwestycji')) {
            tmp.push({
                key: 'regard',
                values: ['Lokalizacja inwestycji celu publicznego']
            })

        } else if (window.location.href.includes('warunki_zabudowy')) {
            tmp.push({
                key: 'regard',
                values: ['Warunki zabudowy']
            })
        } else if (window.location.href.includes('zabytki_archeologiczne')) {
            tmp.push({
                key: 'type',
                values: ['C - zabytek archeologiczny']
            })
        } else if (window.location.href.includes('zabytki')) {
            tmp.push({
                key: 'type',
                values: ['A - zabytek nieruchomy', 'B - zabytek ruchomy']
            })
        }

        if (tmp.length !== 0) {
            setInitialFilters(tmp)
        }

        ApiService.getChartData({
            category,
            organization: organization?.toUpperCase(),
            period
        }).then(({data, metadata}) => {
            if (metadata) createFilters(metadata['filters']);
            if (data) {
                if (addValues) {
                    calculateWorker.postMessage({
                        type: 'addValues',
                        data
                    });
                } else {
                    setInitialData(data);
                    if ((!organization && !period) || !(initialFilters.length === 0)) {

                        setData(data);
                    }
                }
            }
        });
    }, [organization, period]);


    useEffect(() => {

        if (organization && period) {
            // @ts-ignore
            const organizationValues = [organizations[organization.toUpperCase()]];

            setNewFiltersMultiple([
                {
                    key: 'organization',
                    values: organizationValues,
                }, {
                    key: 'period',
                    values: [period.toUpperCase()],
                },
                ...initialFilters
            ]);
        } else if (organization) {
            // @ts-ignore
            const orgValues = [organizations[organization.toUpperCase()]];
            setNewFiltersMultiple([
                {
                    key: 'organization',
                    values: orgValues,
                },
                ...initialFilters
            ])
        } else {
            if (initialFilters.length !== 0) {
                setNewFiltersMultiple([
                    ...initialFilters
                ])
            }
        }
    }, [initialData]);


    useEffect(() => {
        calculateWorker.postMessage({
            type: 'newData',
            initialData,
            activeFilters
        });
    }, [activeFilters]);

    return [initialData, data, filters, activeFilters, setNewFilters] as const;
};

export {useFetchData}